// Box icon for Merchandise. Stroke follows the text colour, so it picks up the sidebar's
// normal / hover / active colours like the other menu icons.
const MerchandiseIconSvg = ({
  height = 20,
  width = 20,
  viewBox = '0 0 20 20',
  stroke = 'currentColor',
  strokeWidth = 1.5,
  className = '',
}: {
  height?: number | string;
  width?: number | string;
  viewBox?: string;
  stroke?: string;
  strokeWidth?: number | string;
  className?: string;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3337 5.83317L10.0003 1.6665L1.66699 5.83317V14.1665L10.0003 18.3332L18.3337 14.1665V5.83317Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M1.66699 5.83333L10.0003 10M10.0003 10V18.3333M10.0003 10L18.3337 5.83333M14.167 3.75L5.83366 7.91667"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MerchandiseIconSvg;
